goog.provide("shadow.js.shim.module$date_fns$locale$fr$default");
shadow.js.shim.module$date_fns$locale$fr$default = esm_import$date_fns$locale$fr.default;
